import { render, staticRenderFns } from "./ChatbotBuilder.vue?vue&type=template&id=1e632ca6&scoped=true"
import script from "./ChatbotBuilder.vue?vue&type=script&lang=js"
export * from "./ChatbotBuilder.vue?vue&type=script&lang=js"
import style0 from "./ChatbotBuilder.vue?vue&type=style&index=0&id=1e632ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e632ca6",
  null
  
)

export default component.exports